<template>
    <div class="page-banner-setting">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">Banner設置</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd">新增</div>
                </div>
            </div>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="img">
                    <div class="table-img-wrap">
                        <img :src="row.url" alt="">
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="status">
                    <div class="cell-btn-group">
                        <div class="cell-btn style1" v-if="row.status == 1">展示</div>
                        <div class="cell-btn style2" v-else>隱藏</div>
                    </div>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(index)">刪除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
   export default {
      data() {
         return {
            pageIndex: 1,   //页码
            curPageSize: 10,    //一页数量
            totalCount: 1, //总条数
            pageInput: '',  //输入的页码

            form: {
               keywords: ''
            },
            isSubmiting: false,
            table: {
               column: [
                  {
                     title: '圖片名稱',
                     key: 'name',
                     align: 'center',
                     sortable: true,
                     minWidth: 150
                  },
                  {
                     title: '圖片',
                     key: 'url',
                     align: 'center',
                     slot: 'img',
                     minWidth: 200
                  },
                  {
                     title: '類型',
                     key: 'type',
                     align: 'center',
                     maxWidth: 60
                  },
                  {
                     title: '排序',
                     key: 'index',
                     align: 'center',
                     maxWidth: 60
                  },
                  {
                     title: '創建時間',
                     key: 'created_at',
                     align: 'center',
                     sortable: true,
                     minWidth: 160
                  },
                  {
                     title: '操作',
                     slot: 'action',
                     align: 'center',
                     width: 150
                  }
               ],
               data: []
            }
         };
      },
      activated() {
         this.getList();
      },
      mounted() {
         this.getList();
      },
      methods: {
         getList() {
            let form = this.form;
            this.isSubmiting = true;
            this.$Rq.requestAuth({
               url: this.$Api.bannerList,
               method: 'get'
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 0) {
                  let tempArr = [];
                  let resData = res.data.data;

                  for (let i = 0; i < resData.length; i++) {
                     let type;
                     if (resData[i].type === 2) {
                        type = '首頁輪播';
                     }else {
                        type = '廣告輪播'
                     }
                     tempArr.push({
                        id: resData[i].id,
                        name: resData[i].name,
                        created_at: resData[i].created_at,
                        url: resData[i].url,
                        type,
                        index: resData[i].index
                     });
                  }

                  this.totalCount = res.data.count;
                  this.table.data = tempArr;
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },

         handleToAdd() {
            this.$router.push({path: '/bannerSettingAdd'});
         },

         handleEdit(index) {
            let tableData = this.table.data;
            this.$router.push({path: '/bannerSettingEdit?id=' + tableData[index].id});
         },
         handleDelete(index) {
            this.$Modal.confirm({
               title: '提示',
               content: '確定刪除嗎？',
               cancelText: '取消',
               okText: '確定',
               onOk: () => {
                  let tableData = this.table.data;
                  this.isSubmiting = true;

                  this.$Rq.requestAuth({
                     url: this.$Api.bannerDelete + '/' + tableData[index].id,
                     method: 'delete'
                  }).then((res) => {
                     this.isSubmiting = false;

                     if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);

                        this.pageIndex = 1;
                        this.getList();

                     } else {
                        this.$Utils.showTipInfo(res.msg);
                     }
                  }).catch((err) => {
                     this.isSubmiting = false;
                  });

               }
            });
         },

         //pager
         handlePageSizeChange(value) {
            this.pageIndex = 1;
            this.getList();
         },

         handlePageInput() {
            let value = ('' + this.pageInput).replace(/\D/g, '');
            let pageCount = Math.ceil(this.totalCount / this.curPageSize);
            if (value > pageCount) {
               value = pageCount;
            }
            this.pageInput = value;
         },
         handlePageEnter() {
            if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
            if (this.pageInput == 0) {
               this.pageInput = 1;
            }
            this.pageInput = parseInt(this.pageInput);
            this.pageIndex = this.pageInput;
            this.getList();
         },

         handlePageChange(value) {
            this.pageIndex = value;
            this.getList();
         }
      }
   };
</script>

<style lang="scss" scoped>
    @import 'BannerSetting';
</style>